<div class="login-background">
  <div class="card login-container">
    <div class="card-header bp-card-header">
      <h3 class="login-header bp-text">Forget Username?</h3>
    </div>
    <div class="card-body">
      <form #loginForm="ngForm">
        <div class="form-group">
          <label for="inputEmail" class="bp-text login-label">Email</label>
          <input [(ngModel)]="email" name="email" type="email" required class="form-control" id="inputEmail" [email]="true">
          <div *ngIf="userNotFound" class="alert alert-danger">{{message}}</div>
        </div>
        <button type="submit" [disabled]="!loginForm.form.valid" class="btn btn-primary login-btn bp-text" (click)="forgetUserName(email)">Find Username</button>
      </form>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/forget-username/forget-username.component.html